export const SHOW_SHADOWS_MODAL = 'SHOW_SHADOWS_MODAL';
export const HIDE_SHADOWS_MODAL = 'HIDE_SHADOWS_MODAL';
export const SET_SHADOWS_OBJ = 'SET_SHADOWS_OBJ';

export function showShadowsModal() {
  return {
    type: SHOW_SHADOWS_MODAL,
  }
}

export function hideShadowsModal() {
  return {
    type: HIDE_SHADOWS_MODAL,
  }
}

export function setShadowsObj(shadowsObj) {
  return {
    type: SET_SHADOWS_OBJ,
    shadowsObj: shadowsObj
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/shadows.js